import { apiClient } from './client';
import type { ApiResponse } from '@/types/api.types';
import type {
  AgeingProfileDto,
  CreateAgeingProfileCommand,
  UpdateAgeingProfileCommand,
} from '@/types/ageingProfile.types';

export const ageingProfileApi = {
  /** GET /api/v1/ageing-profiles — all profiles, optionally narrowed to one party type */
  list: (partyType?: string) =>
    apiClient.get<ApiResponse<AgeingProfileDto[]>>('/ageing-profiles', { params: { partyType } }),

  /** GET /api/v1/ageing-profiles/{id} */
  get: (id: string) =>
    apiClient.get<ApiResponse<AgeingProfileDto>>(`/ageing-profiles/${id}`),

  /** POST /api/v1/ageing-profiles */
  create: (command: CreateAgeingProfileCommand) =>
    apiClient.post<ApiResponse<{ id: string }>>('/ageing-profiles', command),

  /** PUT /api/v1/ageing-profiles/{id} */
  update: (id: string, command: UpdateAgeingProfileCommand) =>
    apiClient.put<ApiResponse<void>>(`/ageing-profiles/${id}`, command),

  /** POST /api/v1/ageing-profiles/{id}/set-default */
  setDefault: (id: string) =>
    apiClient.post<ApiResponse<void>>(`/ageing-profiles/${id}/set-default`),

  /** DELETE /api/v1/ageing-profiles/{id} */
  remove: (id: string) =>
    apiClient.delete<ApiResponse<void>>(`/ageing-profiles/${id}`),
};
